import React from 'react'
import { Link } from 'react-router-dom';

// Importing Components
import Footer from '../components/Footer';
import GoodPoint from '../components/GoodPoint';
import LastGoodPoint from '../components/LastGoodPoint';
import AboutExhibition from '../components/AboutExhibition';
import Testimonials from '../components/Testimonials';

// Importing Images
import GoodPointOne from "../images/features-1.png";
import GoodPointTwo from "../images/features-2.png";
import GoodPointThree from "../images/features-3.png";
import GoodPointFour from "../images/features-4.png";
import GoodPointFive from "../images/features-5.png";
import ExhibitionOne from '../images/exhibition-1.png';
import ExhibitionTwo from '../images/exhibition-2.png';
import ExhibitionThree from '../images/exhibition-3.png';
import homeSofaSet from "../images/home-sofa-set.jpg";


export default function AboutUs() {
  return (
    <>
      <div className="container-fluid home-container mb-5">
        {/* Header Start */}
        <div className="row pt-3">
          <div className="col-12 about-header">
            <div className="header-headings">
              <h1 className='mb-1'>MORE</h1>
              <h1 className='mb-0'>ABOUT US</h1>
            </div>
            <Link to='/all-products' className='btn rounded-0 header-home-page-btn'>Explore Store</Link>
          </div>
        </div>
        {/* Header End */}

        {/* GoodPoints Banner Start */}
        <div className="container-fluid px-0 mb-5 mt-2 section-3-home-page">
          <div className="row align-items-start">
            <GoodPoint
              img={GoodPointOne}
              title="10 Years Experience"
            />
            <GoodPoint
              img={GoodPointTwo}
              title="Flexible Delivery"
            />
            <GoodPoint
              img={GoodPointThree}
              title="Free Installation"
            />
            <GoodPoint
              img={GoodPointFour}
              title="After Sales Support"
            />
            <LastGoodPoint
              img={GoodPointFive}
              title="5 Years Warranty"
            />
          </div>
        </div>
        {/* GoodPoints Banner End */}

        {/* Permanent Exhibitions Section Start */}
        <div className="row section-3-about-page align-items-stretch">
          <div className="col-md-6 col-12 image-side d-none d-md-block"></div>
          <div className="col-md-6 col-12 details-side">
            <h2 className='text-center text-md-start'>Permanent Exhibitions</h2>
            <AboutExhibition
              exbImg={ExhibitionOne}
              exbTitle="Unique & Minimal Design"
              exbDesc="Quae semper modi tenetur sem suscipit corporis. Cupidatat facilisis pariatur venena."
            />
            <AboutExhibition
              exbImg={ExhibitionTwo}
              exbTitle="High Quality Material"
              exbDesc="Quae semper modi tenetur sem suscipit corporis. Cupidatat facilisis pariatur venena."
            />
            <AboutExhibition
              exbImg={ExhibitionThree}
              exbTitle="Crafted Carefully"
              exbDesc="Quae semper modi tenetur sem suscipit corporis. Cupidatat facilisis pariatur venena."
            />
          </div>
        </div>
        {/* Permanent Exhibitions Section End */}

        {/* Product Showcase Section Start */}
        <div className="row section-4-about-page mt-5 pt-1">
          <div className="col-md-6 col-sm-9 col-12 order-md-1 order-2 mx-md-0 mx-auto details-side position-relative d-flex flex-column justify-content-center align-items-start">
            <h2 className='text-center text-md-start w-100'>Repellat Montes!</h2>
            <p className='text-center text-md-start'>
              Quisque vitae dapibus leo. Morbi dictum, lectus ut scelerisque mattis, eros lacus mollis metus.
            </p>
          </div>
          <div className="col-md-6 col-sm-9 col-12 order-md-2 order-1 mx-md-0 mx-auto image-side px-0">
            <img src={homeSofaSet} className='d-block mx-auto' alt="Home Sofa Set" />
          </div>
        </div>
        {/* Product Showcase Section End */}

        {/* Testimonials Section Start */}
        <Testimonials />
        {/* Testimonials Section End */}

      </div>
      <Footer />
    </>
  )
}
